import { takeLatest, call, put, all, select } from "redux-saga/effects";
import { setData } from "@lib/storage";

import {
  SET_SELECTED_CONTACT,
  SET_SELECTED_CONTACT_SUCCESS,
} from "../reducers/actionTypes";

function* setSelectedContact({ payload }) {
  try {
    yield call(setData, "selectedContact", payload);
  } catch (error) {
    console.log(error);
  }
}
export default function* root() {
  yield all([takeLatest(SET_SELECTED_CONTACT, setSelectedContact)]);
}
